import Vue from 'vue';

import dataItems from '@/_CRUDL/helpers/data/items';

function mutationGenerator(key, constants, kind, multiple = true) {
  const itemOrItems = multiple ? 'items' : 'item';

  function handle(state, response) {
    // no direct response.data here.
    // backwards compatibility issues, maybe?
    let data = {};

    const appending = state.list.filters.CRUDL_append;

    if (key) {
      try {
        data = dataItems(response.data[key], 'id');
      } catch (err) { /* */ }
    } else if (response && response.data) {
      // eslint-disable-next-line prefer-destructuring
      data = response.data;
    }

    if (kind === 'list') {
      if (state.list.filters.page) {
        try {
          Object
            .keys(data)
            .filter(i => data[i].id)
            .forEach((i) => {
              // eslint-disable-next-line no-underscore-dangle, no-param-reassign
              data[i]._CRUDL_PAGE = state.list.filters.page;
            });
        } catch (err) { /* */ }
      }

      if (appending) {
        data = {
          ...data,
          ...state.list.items,
        };
      }
    }

    const { id } = data;

    if (id) {
      if (kind === 'update') {
        if (state.read.item.id === id) {
          state.read.item = data;
        }
      }

      if (['create', 'read', 'update'].indexOf(kind) > -1) {
        const list = state.list.items;
        const existent = list[id] || {};

        state.list.items = {
          ...list,
          [id]: {
            ...existent,
            ...data,
          },
        };
      }
    }

    if (kind === 'delete') {
      let originalID;

      try {
        originalID = response.config.params.id;
      } catch (err) {
        try {
          originalID = response.config.id;
        } catch (err2) { /* */ }
      }

      if (originalID && state.list.items[originalID]) {
        Vue.delete(state.list.items, originalID);
      }
    }

    state[kind][itemOrItems] = data;
  }

  return {
    [constants.start]: function startMutation(state) {
      handle(state);

      state[kind].datetime = null;
      state[kind].error = null;
      state[kind].loading = true;
    },
    [constants.success]: function successMutation(state, response) {
      handle(state, response);

      state[kind].datetime = new Date();
      state[kind].error = null;
      state[kind].loading = false;
    },
    [constants.failure]: function failureMutation(state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      if (!details) {
        try {
          details = error.response.data.errors;
        } catch (err) { /* */ }
      }

      handle(state);

      state[kind].datetime = null;
      state[kind].error = details;
      state[kind].loading = false;
    },
    [constants.clear]: function clearMutation(state) {
      state[kind][itemOrItems] = {};

      state[kind].datetime = null;
      state[kind].error = null;
      state[kind].loading = false;
    },
  };
}

function filterMutationGenerator(constants) {
  return {
    [constants.filter]: function filterMutation(state, payload) {
      state.list.filters = {
        ...state.list.filters,
        ...payload,
      };
    },
  };
}

export default function (keys, constants) {
  return {
    ...mutationGenerator(keys.create, constants.create, 'create', false),
    ...mutationGenerator(keys.read, constants.read, 'read', false),
    ...mutationGenerator(keys.update, constants.update, 'update', false),
    ...mutationGenerator(keys.delete, constants.delete, 'delete', false),
    ...mutationGenerator(keys.list, constants.list, 'list', true),
    ...filterMutationGenerator(constants.list),
  };
}
